import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DespachoCoordinadoresReportDialogData {
    coordinador: string;
    year: number;
}

export interface DespachoCoordinadoresReportDialogResult {
    dateFrom: Date;
    dateTo: Date;
}

@Component({
    selector: 'app-despacho-coordinadores-report-popup',
    templateUrl: './despacho-coordinadores-report-popup.component.html',
    styleUrls: ['./despacho-coordinadores-report-popup.component.scss'],
    standalone: false,
})
export class DespachoCoordinadoresReportPopupComponent {
    dateFrom: Date;
    dateTo: Date;
    validationMessage: string = '';

    constructor(
        private dialogRef: MatDialogRef<DespachoCoordinadoresReportPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DespachoCoordinadoresReportDialogData
    ) {
        this.dateFrom = new Date(data.year, 0, 1);
        this.dateTo = new Date(data.year, 11, 31);
    }

    cancelar(): void {
        this.dialogRef.close();
    }

    aceptar(): void {
        this.validationMessage = '';

        if (!this.dateFrom || !this.dateTo) {
            this.validationMessage = 'Debe indicar ambas fechas.';
            return;
        }

        if (this.dateFrom > this.dateTo) {
            this.validationMessage = 'La fecha inicial no puede ser posterior a la final.';
            return;
        }

        this.dialogRef.close({
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
        } as DespachoCoordinadoresReportDialogResult);
    }
}
